import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// What is currently on screen, published by the chart so that the notices, the
// export and anything else can describe the same view without prop drilling
// through Chart.

const defaultValues = {
	rows: [],
	withheld: 0,
	weightingIsPublished: true,
	year: null,
	setView: () => {},
};

const ViewContext = createContext(defaultValues);

export const ViewProvider = ({ children }) => {
	const [view, setViewState] = useState(defaultValues);

	// Stable identity: the chart calls this from an effect.
	const setView = useCallback((next) => setViewState((previous) => ({ ...previous, ...next })), []);

	const value = useMemo(() => ({ ...view, setView }), [view, setView]);

	return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
};

export const useViewContext = () => useContext(ViewContext);
